/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const isMac = navigator.userAgent.includes('Mac');
const uniq = (arr) => [...new Set(arr)];
export const xor = (a, b) => uniq([...a, ...b].filter((id) => !a.includes(id) || !b.includes(id)));
export const mapValues = (obj, fn) => Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, fn(value)]));
export const searchProperties = (properties, text) => {
    var _a;
    for (const [propName, propValue] of Object.entries(properties)) {
        const isNameMatch = propName.toLowerCase().includes(text);
        const raw = (_a = propValue === null || propValue === void 0 ? void 0 : propValue.stringified) !== null && _a !== void 0 ? _a : '';
        const isValueMatch = raw.toLowerCase().includes(text);
        if (isNameMatch || isValueMatch) {
            return true;
        }
    }
    return false;
};
export const searchNodes = (nodes, text) => {
    const q = text.toLowerCase();
    return nodes
        .filter((node) => {
        var _a;
        if ((_a = node.labelsSorted) === null || _a === void 0 ? void 0 : _a.some((l) => l.toLowerCase().includes(q))) {
            return true;
        }
        return searchProperties(node.properties, q);
    })
        .map((node) => node.id);
};
export const searchRels = (rels, text) => {
    const q = text.toLowerCase();
    return rels
        .filter((rel) => {
        if (rel.type.toLowerCase().includes(q)) {
            return true;
        }
        return searchProperties(rel.properties, q);
    })
        .map((rel) => rel.id);
};
//# sourceMappingURL=utils.js.map